import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';



export type SPUploadConfirmationLocs =
  'SPUploadConfirmationFieldLabelActiveDate' |
  'SPUploadConfirmationFieldLabelExpireDate' |
  'SPUploadConfirmationFieldLabelProvider' |
  'SPUploadConfirmationFieldLabelDocLanguage' |
  'SPUploadConfirmationFieldLabelDocumentation' |
  'SPUploadConfirmationFieldLabelDocNotes' |
  'SPUploadConfirmationTextNever' |
  'SPUploadConfirmationTextPoints' |
  'SPUploadConfirmationButtonStepThreeStartOver' |
  'SPUploadConfirmationFieldLabelFactorNotFound';

  export type CPUploadConfirmationLocs =
  'CPUploadConfirmationFieldLabelActiveDate' |
  'CPUploadConfirmationFieldLabelExpireDate' |
  'CPUploadConfirmationFieldLabelProvider' |
  'CPUploadConfirmationFieldLabelDocLanguage' |
  'CPUploadConfirmationFieldLabelDocumentation' |
  'CPUploadConfirmationFieldLabelDocNotes' |
  'CPUploadConfirmationTextNever' |
  'CPUploadConfirmationTextPoints' |
  'CPUploadConfirmationButtonStepThreeStartOver' |
  'CPUploadConfirmationFieldLabelFactorNotFound';

export const spUploadConfirmationLocs: LocDefs<SPUploadConfirmationLocs> = {
  SPUploadConfirmationFieldLabelActiveDate: {
    defaultValue: 'Active Date',
    description: 'Label for the active date field',
    displayPath: 'History|Upload Confirmation|Active Date',
    displayType: 'Label',
    feature: HubFeature.OtherRequirementUpload,
    portal: 'SP',
    legacyName: 'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.FieldLabel.ActiveDate',
  },
  SPUploadConfirmationFieldLabelExpireDate: {
    defaultValue: 'Expire Date',
    description: 'Label for the expire date field',
    displayPath: 'History|Upload Confirmation|Expire Date',
    displayType: 'Label',
    feature: HubFeature.OtherRequirementUpload,
    portal: 'SP',
    legacyName: 'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.FieldLabel.ExpireDate',
  },
  SPUploadConfirmationFieldLabelProvider: {
    defaultValue: 'Provider',
    description: 'Label for the provider field',
    displayPath: 'History|Upload Confirmation|Provider',
    displayType: 'Label',
    feature: HubFeature.OtherRequirementUpload,
    portal: 'SP',
    legacyName: 'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.FieldLabel.Provider',
  },
  SPUploadConfirmationFieldLabelDocLanguage: {
    defaultValue: 'Documentation Language',
    description: 'Label for the documentation language field',
    displayPath: 'History|Upload Confirmation|Documentation Language',
    displayType: 'Label',
    feature: HubFeature.OtherRequirementUpload,
    portal: 'SP',
    legacyName: 'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.FieldLabel.DocLanguage',
  },
  SPUploadConfirmationFieldLabelDocumentation: {
    defaultValue: 'Documentation',
    description: 'Label for the documentation field',
    displayPath: 'History|Upload Confirmation|Documentation',
    displayType: 'Label',
    feature: HubFeature.OtherRequirementUpload,
    portal: 'SP',
    legacyName: 'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.FieldLabel.Documentation',
  },
  SPUploadConfirmationFieldLabelDocNotes: {
    defaultValue: 'Notes',
    description: 'Label for the documentation notes field',
    displayPath: 'History|Upload Confirmation|Notes',
    displayType: 'Label',
    feature: HubFeature.OtherRequirementUpload,
    portal: 'SP',
    legacyName: 'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.FieldLabel.DocNotes',
  },
  SPUploadConfirmationTextNever: {
    defaultValue: 'Never',
    description: 'Text displayed when there is no expire date',
    displayPath: 'History|Upload Confirmation|Never',
    displayType: 'Content',
    feature: HubFeature.OtherRequirementUpload,
    portal: 'SP',
    legacyName: 'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.Text.Never',
  },
  SPUploadConfirmationTextPoints: {
    defaultValue: 'Points',
    description: 'Label for the points field',
    displayPath: 'History|Upload Confirmation|Points',
    displayType: 'Label',
    feature: HubFeature.OtherRequirementUpload,
    portal: 'SP',
    legacyName: 'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.Text.Points',
  },
  SPUploadConfirmationButtonStepThreeStartOver: {
    defaultValue: 'Upload Another Item',
    description: 'Text for the button to start over',
    displayPath: 'History|Upload Confirmation|Upload Another Item',
    displayType: 'Button',
    feature: HubFeature.OtherRequirementUpload,
    portal: 'SP',
    legacyName: 'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.Button.StepThreeStartOver',
  },
  SPUploadConfirmationFieldLabelFactorNotFound: {
    defaultValue: 'Points',
    description: 'Label for the points field when factor is not found',
    displayPath: 'History|Upload Confirmation|Factor Not Found',
    displayType: 'Label',
    feature: HubFeature.CredentialContinuingEducation,
    portal: 'SP',
    legacyName: 'Credential.ContinuingEducation/Candidate.ProgramHistory.CEActivity.Details.FieldLabel.FactorNotFound',
  },
};




export const cpUploadConfirmationLocs: LocDefs<CPUploadConfirmationLocs> = {
	CPUploadConfirmationFieldLabelActiveDate: {
	  defaultValue: 'Active Date',
	  description: 'Label for the active date field',
	  displayPath: 'History|Upload Items|Label|Active Date',
	  displayType: 'Label',
	  feature: HubFeature.OtherRequirementUploadCandidateAccess,
	  portal: 'CP',
	  legacyName: 'OtherRequirement.Upload.CandidateAccess/History.UploadItems.FieldLabel.ActiveDate',
	},
	CPUploadConfirmationFieldLabelExpireDate: {
	  defaultValue: 'Expire Date',
	  description: 'Label for the expire date field',
	  displayPath: 'History|Upload Items|Label|Expire Date',
	  displayType: 'Label',
	  feature: HubFeature.OtherRequirementUploadCandidateAccess,
	  portal: 'CP',
	  legacyName: 'OtherRequirement.Upload.CandidateAccess/History.UploadItems.FieldLabel.ExpireDate',
	},
	CPUploadConfirmationFieldLabelProvider: {
	  defaultValue: 'Provider',
	  description: 'Label for the provider field',
	  displayPath: 'History|Upload Items|Label|Provider',
	  displayType: 'Label',
	  feature: HubFeature.OtherRequirementUploadCandidateAccess,
	  portal: 'CP',
	  legacyName: 'OtherRequirement.Upload.CandidateAccess/History.UploadItems.FieldLabel.Provider',
	},
	CPUploadConfirmationFieldLabelDocLanguage: {
	  defaultValue: 'Documentation Language',
	  description: 'Label for the documentation language field',
	  displayPath: 'History|Upload Items|Label|Documentation Language',
	  displayType: 'Label',
	  feature: HubFeature.OtherRequirementUploadCandidateAccess,
	  portal: 'CP',
	  legacyName: 'OtherRequirement.Upload.CandidateAccess/History.UploadItems.FieldLabel.DocLanguage',
	},
	CPUploadConfirmationFieldLabelDocumentation: {
	  defaultValue: 'Documentation',
	  description: 'Label for the documentation field',
	  displayPath: 'History|Upload Items|Label|Documentation',
	  displayType: 'Label',
	  feature: HubFeature.OtherRequirementUploadCandidateAccess,
	  portal: 'CP',
	  legacyName: 'OtherRequirement.Upload.CandidateAccess/History.UploadItems.FieldLabel.Documentation',
	},
	CPUploadConfirmationFieldLabelDocNotes: {
	  defaultValue: 'Notes',
	  description: 'Label for the documentation notes field',
	  displayPath: 'History|Upload Items|Label|Notes',
	  displayType: 'Label',
	  feature: HubFeature.OtherRequirementUploadCandidateAccess,
	  portal: 'CP',
	  legacyName: 'OtherRequirement.Upload.CandidateAccess/History.UploadItems.FieldLabel.DocNotes',
	},
	CPUploadConfirmationTextNever: {
	  defaultValue: 'Never',
	  description: 'Text displayed when there is no expire date',
	  displayPath: 'History|Upload Items|Content|Never',
	  displayType: 'Content',
	  feature: HubFeature.OtherRequirementUploadCandidateAccess,
	  portal: 'CP',
	  legacyName: 'OtherRequirement.Upload.CandidateAccess/History.UploadItems.Text.Never',
	},
	CPUploadConfirmationTextPoints: {
	  defaultValue: 'Points',
	  description: 'Label for the points field',
	  displayPath: 'History|Upload Items|Text|Points',
	  displayType: 'Label',
	  feature: HubFeature.OtherRequirementUploadCandidateAccess,
	  portal: 'CP',
	  legacyName: 'OtherRequirement.Upload.CandidateAccess/History.UploadItems.Text.Points',
	},
	CPUploadConfirmationButtonStepThreeStartOver: {
	  defaultValue: 'Upload Another Item',
	  description: 'Text for the button to start over',
	  displayPath: 'History|Upload Items|Button|Upload Another Item',
	  displayType: 'Button',
	  feature: HubFeature.OtherRequirementUploadCandidateAccess,
	  portal: 'CP',
	  legacyName: 'OtherRequirement.Upload.CandidateAccess/History.UploadItems.Button.StepThreeStartOver',
	},
	CPUploadConfirmationFieldLabelFactorNotFound: {
	  defaultValue: 'Points',
	  description: 'Label for the points field when factor is not found',
	  displayPath: 'History|Upload Items|Label|Factor Not Found',
	  displayType: 'Label',
	  feature: HubFeature.OtherRequirementUploadCandidateAccess,
	  portal: 'CP',
	},
  };

export type SPUploadConfirmationLocKeys = LocMap<SPUploadConfirmationLocs>;
export const spUploadConfirmationLocKeys: SPUploadConfirmationLocKeys =
  MapLocKeys<SPUploadConfirmationLocs>(spUploadConfirmationLocs);

export type CPUploadConfirmationLocKeys = LocMap<CPUploadConfirmationLocs>;
export const cpUploadConfirmationLocKeys: CPUploadConfirmationLocKeys =
	MapLocKeys<CPUploadConfirmationLocs>(cpUploadConfirmationLocs);

